import { resourceLoaders } from './resourceLoaders'

export async function getResource(resourceType, resourceId) {
  return await resourceLoaders[resourceType](resourceId)
}
